import onDocumentLoaded from '../lib/onDocumentLoaded';

export default function init() {
	onDocumentLoaded(document, () => {
		const areaOfInterestFieldId = 'area_of_interest_-794d08af-92e2-4c4c-81a5-f877ff396c3a';
		const areaOfInterestField = document.getElementById(areaOfInterestFieldId);

		if (!areaOfInterestField) {
			return;
		}

		function getQueryParameterValue(parameterName: string) {
			const urlParams = new URLSearchParams(window.location.search);
			return urlParams.get(parameterName);
		}
		
		// Set the form field value using the query parameter
		function setFormFieldValue(parameterName: string) {
			const parameterValue = getQueryParameterValue(parameterName);
			
			if (areaOfInterestField instanceof HTMLSelectElement && parameterValue) {
				areaOfInterestField.value = parameterValue;
			}
		}
	
		setFormFieldValue('interest');
	}, true);
}